import { Coding } from './coding.model';

export class CodingPage {
  public totalPages: number;
  constructor(public codings: Coding[], public pageNum: number, public pageSize: number, public searchTotal: number) {
    this.totalPages = Math.ceil(searchTotal / pageSize);
  }
}
